import React, { useEffect, useState } from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { CheckBox, NumberBox, SelectBox, TagBox, TextArea } from 'devextreme-react';
import { TextBox } from 'devextreme-react/text-box';
import saveIconWhite from '../../../images/save-icon-white.svg';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/modal/modalSlice';
import { createCustomer, editCustomer } from '../../../redux/customers/thunks';
import { getContract } from '../../../redux/contract/thunks';
import { errorHandler } from '../../../commonFunctions/errorHandler';
import { RequiredRule, Validator } from 'devextreme-react/validator';
import { validateEmail } from '../../../commonFunctions/commonFunctions';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="input-admin">
      <label className={classes?.label}>{label}</label>
      <div style={{ width: '75%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

function CustomerDialog(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { contract, dialogSize, open, onClose } = props;
  const [phoneMask, setPhoneMask] = useState('+00 (00) 0000-0000');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleMaskChange = (e) => {
    const value = e.value || '';
    if (value.startsWith('+')) {
      setPhoneMask('+00 (00) 0000-0000'); // International format
    } else {
      setPhoneMask('(00) 0000-0000'); // Local format
    }
  };

  const dialogStyles = {
    // width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
    // height: operation !== 'delete' ? (dialogSize?.height || '180px') : '180px',
    width: '550px',
    height: '100%',
    minWidth: 'max-content',
  };

  const buttonStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    margin: 'auto',
    marginTop: '5px',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const buttonSaveStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    marginRight: '16px',
    marginTop: '5px',
    float: 'right',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const closeButton = {
    position: 'absolute',
    right: '6px',
    top: '0px',
  };


  const [dataForm, setDataForm] = useState({});
  const [formOperation, setFormOperation] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const [title, setTitle] = useState();
  const [operation, setOperation] = useState();

  useEffect(() => {
    if (open && contract) {
      setDataForm({
        CPF: contract.customerCPF,
        CustomerName: contract.customerName,
        Phone: contract.customerPhone,
        Email: contract.customerEmail,
        Address: contract?.customerAddress,
        ZipCode: contract?.customerZipCode,
        City: contract?.customerCity,
        Neighborhood: contract.customerNeighborhood,
        State: contract.customerState
      });

      setTitle(contract?.customerId == null ? 'Cadastrar Cliente' : 'Editar Cliente');
      setOperation(contract.customerPhone == null ? 'delete' : '');
    }
  }, [open]);

  

  function onChange(main, value) {
    if (value == null || value == undefined) return;
    //if (main.toLowerCase() === 'phone') value = value.toString().replace(/[^0-9+]/g, '');
    //if (main.toLowerCase() === 'cep') value = value.toString().replace(/[^0-9]/g, '');

    setDataForm((prevState) => ({ ...prevState, [main]: value }));
  }
  async function handleSubmit() {
    setIsSubmitting(true);

    // Validação de Campos
    if (!dataForm.CustomerName || dataForm.CustomerName.trim() === '') {
      dispatch(openModal({ type: 'warning', message: `O campo Nome é obrigatório` }));
      setIsSubmitting(false);
      return false;
    }
    if (!dataForm.Phone || dataForm.Phone <= 0) {
      dispatch(openModal({ type: 'warning', message: `O campo Telefone é obrigatório` }));
      setIsSubmitting(false);
      return false;
    }
    
    if (dataForm.Email) {
        if(!validateEmail(dataForm.Email)){
            dispatch(openModal({ type: 'warning', message: `Formato de e-mail inválido` }));
            setIsSubmitting(false);
            return false;
        }
    }

    // if (!validateCNPJ(customerDataForm.CNPJ)) {
    //   dispatch(openModal({ type: 'warning', message: `Formato de CNPJ inválido` }));
    //   return false;
    // }

    // if (customerDataForm.CEP) {
    //   if (customerDataForm.CEP.length !== 8) {
    //     dispatch(openModal({ type: 'warning', message: `O campo CEP deve conter 8 caracteres` }));
    //     return false;
    //   }
    // }

    // if (customerDataForm.Email) {
    //   if (!validateEmail(customerDataForm.Email)) {
    //     dispatch(openModal({ type: 'warning', message: `Formato de e-mail inválido` }));
    //     return false;
    //   }
    // }
    // if (!customerDataForm.Phone) {
    //   dispatch(openModal({ type: 'warning', message: `O campo Teefone é obrigatório` }));
    //   return false;
    // }
    // if (customerDataForm.Phone && customerDataForm.Phone.length < 10) {
    //   dispatch(openModal({ type: 'warning', message: `O campo Telefone deve conter no mínimo 10 caracteres` }));
    //   return false;
    // }

    try {
      if (contract.customerId == null) {
        //await dispatch(createCustomer({ body: customerDataForm }));

        const body = {
            ...dataForm,
            Phone: dataForm?.Phone != null ? dataForm?.Phone.toString() : dataForm?.Phone,
            ZipCode: dataForm?.ZipCode != null ? dataForm?.ZipCode.toString() : dataForm?.ZipCode
        }

        dispatch(createCustomer({ body: body })).then((data) => {
            if(data.error)
            {
              dispatch(openModal({ type: "warning", message:data.error.message}))
            }
            else{
              dispatch(getContract({ query: '?plate=' + dataForm.Phone }));
              onClose();
            }
            setIsSubmitting(false);
        })
      } else {
        //await dispatch(editCustomer({ body: customerDataForm }));
        const editCustomerParams ={
            param: contract.customerId,
            customerId: contract.customerId,
            body:{
              ...dataForm,
              Phone: dataForm?.Phone != null ? dataForm?.Phone.toString() : dataForm?.Phone,
            ZipCode: dataForm?.ZipCode != null ? dataForm?.ZipCode.toString() : dataForm?.ZipCode
            }
        }
        dispatch(editCustomer(editCustomerParams)).then((data) => {
            if(data.error)
            {
              dispatch(openModal({ type: "warning", message:data.error.message}))
            }
            else{
              dispatch(getContract({ query: '?plate=' + dataForm.Phone }));
              onClose();
            }
            setIsSubmitting(false);
        })
      }
      
    } catch (err) {
      dispatch(openModal(errorHandler(err)));
      setIsSubmitting(false);
    }

    
  }

  return (
    <Dialog maxWidth={'xl'} open={open} onClose={onClose} style={{ borderRadius: 0 }}>
      <div style={dialogStyles}>
        <DialogTitle disableTypography className="titleStyles">
          {title}
          {/* {operation !== 'delete' && <IconButton onClick = {onClose} style = {closeButton}> <Close style={{color: "white"}}/> </IconButton>} */}
          <IconButton onClick={onClose} style={closeButton}>
            <Close />
          </IconButton>
        </DialogTitle>
        <hr class="MuiDivider-root" style={{ width: '100%', backgroundColor: 'black' }}></hr>

        <DialogContent>
          <div style={{ display: 'flex', flexFlow: 'column', rowGap: '1rem' }}>
            {contract.customerCPF == null ?
            (
              <TextBox
              label={'CPF'}
              key={'CPF'}
              //disabled={editMode}
              name="CPF"
              mask="000.000.000-00"
              placeholder="000.000.000-00"
              showMaskMode="onFocus"
              maskRules={{ 0: /[0-9]/ }}
              value={dataForm?.CPF}
              onValueChanged={(e) => onChange('CPF', e.value)}
            ></TextBox>
            ): (
              <TextBox disabled={true} label={'CPF'} key={'CPF'} name="CPF" value={dataForm?.CPF}></TextBox>
            )}

            <TextBox label={'Nome*'} key={'CustomerName'} name="CustomerName" value={dataForm?.CustomerName} onValueChanged={(e) => onChange('CustomerName', e.value)}>
              <Validator><RequiredRule message="O campo Nome é obrigatório" /></Validator>
            </TextBox>
            {/* <TextBox label={'Telefone*'} key={'Phone'} name="Phone" value={dataForm?.Phone} onValueChanged={(e) => onChange('Phone', e.value)}></TextBox> */}
            <NumberBox label={'Telefone*'} labelMode="floating" key={'Phone'} value={dataForm?.Phone} onValueChanged={(e) => onChange('Phone', e.value)}>
              <Validator><RequiredRule message="O campo Telefone é obrigatório" /></Validator>
            </NumberBox>

            <TextBox label={'E-mail'} mode="email" key={'Email'} name="Email" value={dataForm?.Email} onValueChanged={(e) => onChange('Email', e.value)}></TextBox>

            <TextBox label={t("Address.Name")} key={'Address'} name={t("Address.Name")} value={dataForm?.Address} onValueChanged={(e) => onChange('Address', e.value)}></TextBox>
            {/* <TextBox label={t("Address.ZipCode")} key={'ZipCode'} name={t("Address.ZipCode")} value={dataForm?.ZipCode} onValueChanged={(e) => onChange('ZipCode', e.value)}></TextBox> */}
            <NumberBox label={t("Address.ZipCode")} labelMode="floating" key={'ZipCode'} value={dataForm?.ZipCode} onValueChanged={(e) => onChange('ZipCode', e.value)}/>

            <TextBox label={t("Address.City")} key={'City'} name={t("Address.City")} value={dataForm?.City} onValueChanged={(e) => onChange('City', e.value)}></TextBox>
            <TextBox label={t("Address.Neighborhood")} key={'Neighborhood'} name={t("Address.Neighborhood")} value={dataForm?.Neighborhood} onValueChanged={(e) => onChange('Neighborhood', e.value)}></TextBox>
            <TextBox label={t("Address.State")} key={'State'} name={t("Address.State")} value={dataForm?.State} onValueChanged={(e) => onChange('State', e.value)}></TextBox>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ display: 'flex', gap: '1rem', paddingRight: 16 }}>
            {operation === 'delete' ? (
              <>
                <Button disabled={isSubmitting} variant="contained" onClick={onClose}>
                  Cancelar
                </Button>

                <Button disabled={isSubmitting}  variant="contained" color="primary" onClick={handleSubmit} startIcon={<img src={saveIconWhite} />}>
                  Salvar
                </Button>
              </>
            ) : (
              <Button disabled={isSubmitting} variant="contained" color="primary" onClick={handleSubmit} startIcon={<img src={saveIconWhite} />}>
                Editar
              </Button>
            )}
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default CustomerDialog;
